<template>
  <basicContainer>
    <div class="yytbgl">
      <!-- 预约填报管理 -->
      <avue-crud
        :data="data"
        :option="option"
        :page.sync="page"
        @on-load="onLoad"
        :search.sync="search"
        @search-change="searchChange"
        @search-reset="searchReset"
        @refresh-change="refreshChange"
        @row-del="rowDel"
        @row-update="rowUpdate"
      ></avue-crud>
    </div>
  </basicContainer>
</template>

<script>
export default {
  data() {
    return {
      data: [],
      option: {
        dialogDrag: true,
        dialogClickModal: false,
        stripe: true,
        border: true,
        page: true,
        selection: false,
        align: "left",
        menuAlign: "center",
        menuWidth: 230,
        searchMenuSpan: 6,
        columnBtn: false,
        refreshBtn: true,
        labelWidth: 150,
        viewBtn: true,
        addBtn: false,
        editBtn: true,
        delBtn: true,
        column: [
          {
            label: "公司名称",
            prop: "corporateName",
            search: true
          },
          {
            label: "人员规模",
            prop: "staffSize",
            search: true,
            type: "select",
            dicData: [
                {
                    label: '0-20人',
                    value: '0-20人'
                },
                {
                    label: '20-50人',
                    value: '20-50人'
                },
                {
                    label: '50-200人',
                    value: '50-200人'
                },
                {
                    label: '200-500人',
                    value: '200-500人'
                },
                {
                    label: '500人以上',
                    value: '500人以上'
                }
            ]
          },
          {
            label: "姓名",
            prop: "name",
            search: true
          },
          {
            label: "手机号码",
            prop: "mobile",
            search: true
          },
          {
            label: "创建时间",
            prop: "createTime",
            editDisplay:false,
            addDisplay:false
          }
        ]
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        pageSizes: [10, 20, 30, 40, 50, 100],
        total: 0
      },
      search: {}
    };
  },
  methods: {
    load(done) {
      this.$http
        .get("/t-appointment-filling/queryPage", {
          params: {
            pageNum: this.page.currentPage,
            pageSize: this.page.pageSize,
            ...this.search
          }
        })
        .then(res => {
          this.data = res.data.records || [];
          this.page.total = res.data.total || res.data.records.length || 0;
        })
        .catch(error => {
          this.$message.error(error.msg || error.message);
        })
        .finally(() => {
          typeof done === "function" && done();
        });
    },
    onLoad(page) {
      this.page.currentPage = page.currentPage;
      this.page.pageSize = page.pageSize;
      this.load();
    },
    searchChange(params, done) {
      this.search = params;
      this.page.currentPage = 1;
      this.load(done);
    },
    searchReset() {
      this.search = {};
      this.page.currentPage = 1;
      this.load();
    },
    refreshChange(){
        this.load()
    },
    rowDel(row,index){
        this.$confirm('是否确认删除', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            this.$http.post("/t-appointment-filling/delAppointmentFilling",null,{
                params:{
                    id:row.id
                }
            }).then(res=>{
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                this.load()
            }).catch(error=>{
                this.$message.error(error.msg||error.message)
            })
          
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    rowUpdate(row,index,done,loading){
        this.$http.put("/t-appointment-filling/updateAppointmentFilling",null,{params:row}).then(res=>{
            // console.log(res)
            this.$message.success(res.data)
            this.load()
            done()
        }).catch(error=>{
            this.$message.error(error.msg||error.message) 
            loading()
        })
    }
  }
};
</script>

<style></style>
